<template>
  <div class="py-8">
    <v-app-bar flat color="transparent">
      <app-bar-nav-icon />
      <v-toolbar-title class="breadcrumbs d-flex align-center">
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link
          class="text-decoration--none"
          :to="{ name: 'course-categories' }"
        >
          Course Category</router-link
        >
      </v-toolbar-title>
    </v-app-bar>

    <div class="ma-4">
      <div class="display-1 font-weight-bold my-5 text-capitalize">
        Add Course Category
      </div>

      <div class="col-xl-4 col-lg-6 col-md-12 mt-6 pa-0">
        <v-form @submit.prevent="submit" ref="form">
          <v-divider class="pb-5"></v-divider>

          <label class="text-field-label">Course Category Name</label>
          <v-text-field
            flat
            solo
            required
            counter
            class="mt-2"
            :rules="rules.label"
            maxlength="255"
            v-model="form.label"
            :error-messages="form.$getError('label')"
          ></v-text-field>
          <v-divider class="my-5"></v-divider>
          <div class="mt-4">
            <v-btn type="submit" color="primary" :loading="form.$busy"
              >Submit</v-btn
            >
          </div>
        </v-form>
      </div>
    </div>
    <v-snackbar v-model="snackbar.show" right :color="snackbar.color">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="snackbar.show = false" v-bind="attrs">OK</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { each } from 'lodash'
import { mapActions, mapState } from 'vuex'
import { mdiChevronLeft } from '@mdi/js'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import Form from '@/utils/form'

export default {
  name: 'CourseCategoryCreate',

  components: {
    AppBarNavIcon,
  },

  data() {
    return {
      photoCover: null,
      showCategoryUpload: false,
      showUpload: false,
      form: new Form({
        label: '',
      }),
      icons: {
        arrowLeft: mdiChevronLeft,
      },
      rules: {
        label: [(v) => (v && v.length <= 255) || 'Max 255 characters'],
      },
      snackbar: {
        show: false,
        message: null,
        color: '',
      },
    }
  },

  computed: {
    ...mapState({
      courseCategoryDetails: (state) =>
        state.courseCategory.courseCategoryDetails,
    }),
  },

  methods: {
    ...mapActions({
      storeCourseCategory: 'courseCategory/storeCourseCategory',
    }),

    async submit() {
      this.form.$busy = true
      this.form.$clearErrors()

      const formData = new FormData()

      each(this.form.$data(), (value, key) => {
        formData.append(key, value)
      })

      this.storeCourseCategory(formData)
        .then(() => {
          this.showSnackbar('Course Category successfully created!', 'success')

          setTimeout(() => {
            this.$router.push({
              name: 'course-categories',
            })
          }, 1000)
        })
        .catch((err) => {
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }

          this.form.$busy = false
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
  },
}
</script>
